// Shopify public-app OAuth client id (configured in the Shopify Partner app).
export const SHOPIFY_PUBLIC_APP_CLIENT_ID = "3b17d81b51b83bc1a5b78ad9f50a5982";

// Builds the Shopify public-app OAuth authorize URL. `state` is carried through
// only when the workspace is already known (in-app/review flow); the App Store
// install flow has no entity yet and omits it.
export const buildShopifyAuthorizeUrl = (
  store: string,
  { state }: { state?: string } = {}
) => {
  const params = new URLSearchParams({
    client_id: SHOPIFY_PUBLIC_APP_CLIENT_ID,
    redirect_uri: `${window.location.origin}/connections/shopify`,
  });
  if (state) params.set("state", state);
  console.log(
    ">> buildShopifyAuthorizeUrl",
    `https://${store}/admin/oauth/authorize?${params.toString()}`
  );
  return `https://${store}/admin/oauth/authorize?${params.toString()}`;
};
